import { Grid } from "@material-ui/core";
import React from "react";
import SharedTitle from "../Components/SharedForms/SharedTitle";
import { TEXT_COLOR_FT } from "config/config";

const AyudaFt = props => {


    return (
        <div style={{ width: '100%', flexBasis: '100%', marginBottom: 5, color: TEXT_COLOR_FT, backgroundColor: 'white' }}>
            <SharedTitle
                title={'Ayuda'}
            />
            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingLeft:25 }}>
                <p>{'Formulario Ingreso y actualización de datos en ficha técnica para Prestadores Institucional'}</p>
            </Grid>
            <Grid style={{ textAlign: 'justify', paddingLeft:25, paddingRight:25 }}>
                <h3>
                    Objetivo
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    El objetivo de este documento es guiar a los Prestadores Institucionales en el uso del sistema de
                    registro de fichas técnicas, facilitando el ingreso y la actualización de los antecedentes clínicos
                    y administrativos de sus establecimientos de salud ante la Superintendencia de Salud. Este sistema
                    está diseñado para apoyar tanto a los Prestadores Institucionales de atención abierta y cerrada como a
                    los de atención primaria, asegurando que cumplan con los requisitos de registro y manteniendo la información
                    actualizada para su correcta supervisión.
                </p>
                <h3>
                    1. Módulo Datos generales
                </h3>
                <h3 style={{ marginTop: 10, marginBottom: 10 }}>
                    1.1 Identificación del prestador
                </h3>
                <ol style={{ padding: 5, marginLeft: 20 }} type="a">
                    <li style={{ padding: 10 }}>
                        Identificación del prestador
                        <ul style={{ padding: 10 }}>
                            <li style={{ padding: 10 }}>
                                Nombre del prestador:  Es la denominación de un Prestador Institucional de Salud, establecida en la
                                respectiva resolución de Autorización Sanitaria. Debe colocar el nombre del prestador institucional
                                completo, descrito en dicha autorización (denominación).
                            </li>
                            <li style={{ padding: 10 }}>
                                Razón social: Nombre con que una entidad o sociedad mercantil está registrada legalmente.
                            </li>
                            <li style={{ padding: 10 }}>
                                RUT: Rol único tributario del prestador de salud.
                            </li>
                            <li style={{ padding: 10 }}>
                                Código DEIS: código numérico de 6 dígitos que identifica al prestador (Oficina de análisis y estándares, DEIS-MINSAL).
                            </li>
                            <li style={{ padding: 10 }}>
                                Teléfono de contacto: en la actualidad se solicita un número celular.
                            </li>
                            <li style={{ padding: 10 }}>
                                Correo electrónico (si corresponde)
                            </li>
                            <li style={{ padding: 10 }}>
                                Página web (si corresponde)
                            </li>
                        </ul>
                    </li>
                    <li style={{ padding: 10 }}>
                        Dirección del prestador
                        <ul style={{ padding: 10 }}>
                            <li style={{ padding: 10 }}>
                                Región: seleccione la región en la cual se ubica el prestador.
                            </li>
                            <li style={{ padding: 10 }}>
                                Comuna: seleccione la comuna en la cual se ubica el prestador.
                            </li>
                            <li style={{ padding: 10 }}>
                                Ciudad: seleccione la ciudad en la cual se ubica el prestador.
                            </li>
                            <li style={{ padding: 10 }}>
                                Nombre de la calle: Complete el nombre de la calle.
                            </li>
                            <li style={{ padding: 10 }}>
                                Número: Complete el número de la calle.
                            </li>
                            <li style={{ padding: 10 }}>
                                Servicio de Salud: Este aparecerá automáticamente. Verifique que es el correcto.
                            </li>
                        </ul>
                    </li>
                    <li style={{ padding: 10 }}>
                        Horario de atención: En este campo usted debe indicar para las instituciones de atención abierta
                        pública y privada el horario de atención, eligiendo entre las alternativas desplegables,
                        indicando además el número de turnos por día (Este último sólo para los centros de diálisis).
                    </li>
                    <li style={{ padding: 10 }}>
                        Dependencia
                        <ul style={{ padding: 10 }}>
                            <li style={{ padding: 10 }}>
                                Tipo de administración: seleccione el tipo de administrador entre público o privado.
                            </li>
                            <li style={{ padding: 10 }}>
                                Modalidad de atención: selecciones el tipo de modalidad de atención: Atención abierta o atención cerrada.
                            </li>
                            <li style={{ padding: 10 }}>
                                Tipo de administración entre:  Se cargará automáticamente. Verifique que la información es correcta.
                            </li>
                            <li style={{ padding: 10 }}>
                                Administrador: Se cargará automáticamente. Verifique que la información es correcta.
                            </li>
                            <li style={{ padding: 10 }}>
                                Tipo de prestador: desplegará automáticamente Verifique que la información es correcta.
                            </li>
                            <li style={{ padding: 10 }}>
                                Complejidad: Clasificación según nivel de complejidad de cada institución de acuerdo al nivel de prestaciones
                                que entrega. Este aparecerá automáticamente. Verifique que es el correcto.
                            </li>
                        </ul>
                    </li>
                </ol>
                <h3>
                    1.2 Acreditación
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    En esta sección se mostrarán los datos asociados a la(s) acreditaciones que el prestador tenga registrada en la Superintendencia
                    de Salud. Usted debe revisar que la información es correcta.
                </p>
                <ul style={{ padding: 10, marginLeft: 15 }}>
                    <li style={{ padding: 10 }}>
                        Estado de acreditación: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        N° acreditaciones realizadas: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        N° de resolución: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        Año: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        N° de Registro en página web SIS: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        Fecha término vigencia: información automática.
                    </li>
                    <li style={{ padding: 10 }}>
                        Entidad Acreditadora: información automática.
                    </li>
                </ul>
                <h3>
                    1.3 Representantes/Encargados(as).
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Se debe completar la información de cada representante o encargado/a de área. De haber más de uno,
                    usted deberá presionar el signo +. Si usted ya ha completado anteriormente la ficha técnica,
                    campos se llenarán automáticamente. Igualmente debe revisar si la información es correcta.
                    Para cada uno, deberá completar: Nombre, apellido 1, apellido 2, RUT, profesión (listado desplegable),
                    teléfono contacto, correo electrónico y domicilio.
                    Sólo para instituciones privadas abiertas y cerradas se debe indicar El Directorio.
                </p>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    DIRECTORIO: En este apartado debe identificar a cada uno de los miembros del directorio de la
                    institución señalando. De haber más de uno, usted deberá presionar el signo +. El ítem cargo en el
                    directorio sólo se completa si corresponde.
                </p>

                <h3>
                    2. Módulo Capacidad Instalada
                </h3>
                <h3 style={{ marginTop: 10, marginBottom: 10 }}>
                    2.1 Autorización sanitaria o demostración de autorización sanitaria
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    En este Módulo aparecerá automáticamente, la información referente a los procesos de acreditación
                    de la institución. Igualmente debe revisar si la información es correcta.
                </p>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Instalación y funcionamiento de inicio: Esta corresponde a la primera autorización
                    sanitaria otorgada al prestador. En esta etapa debe identificar el N° de resolución (formato numérico),
                    la fecha en que fue otorgada (formato fecha) y la autoridad que la otorgó.
                </p>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Demostración de Autorización sanitaria:  Esta información debe ser completada por los prestadores
                    institucionales, construidos antes de febrero del año 2006 están autorizados por Ley. Válido sólo
                    para instituciones públicas. En esta etapa debe identificar el N° de resolución (formato numérico),
                    la fecha en que fue otorgada (formato fecha) y la autoridad que la otorgó.
                </p>
                <h3>
                    2.2 Instalaciones
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    En este Módulo, en el Menú principal ubicado a la izquierda de su pantalla, usted encontrará un listado
                    de contenidos que debe seleccionar y completar las instalaciones que correspondan a su institución.
                    En cada una de las instalaciones se le solicitará la Autorización sanitaria (si corresponde).  Para
                    cada ítem existe la posibilidad de incorporar “OTROS”. De haber más de uno, usted deberá presionar
                    botón “Agregar” quedando grabado automáticamente en el listado. En la pregunta Tipo de Servicio,
                    usted debe elegir si el servicio es propio o compra el servicio a un tercero.
                </p>
                <h3>
                    2.2.1 Camas
                </h3>
                <ul style={{ padding: 10, marginLeft: 15 }}>
                    <li style={{ padding: 10 }}>
                        Camas Básicas: Destinadas a pacientes que estando en cualquiera de las etapas de una enfermedad,
                        requiere hacer uso de las instalaciones hospitalarias con el fin de que le sean otorgados
                        cuidados médicos y de enfermería básicos. A este nivel se entrega atención en ámbito adulto,
                        pediátrico, neonatológico, gineco-obstétrico. Cuentan con acceso a procedimientos básicos
                        de tipo médico o quirúrgico (menores)
                    </li>
                    <li style={{ padding: 10 }}>
                        Cuidados Medios/ Cama de Cuidados Medios (Tipo C): destinadas a entregar cuidados de mediana
                        complejidad, asociados a una fase aguda de enfermedad del paciente, que debiera compensarse
                        en pocos días.
                    </li>
                    <li style={{ padding: 10 }}>
                        Camas Críticas: destinadas a entregar cuidados de alta complejidad, incluye unidad de
                        tratamientos intermedios, unidad de cuidados críticos entre otras.
                    </li>
                </ul>
                <h3>
                    2.2.2 Unidad de Recuperación
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Recinto en donde se realiza la monitorización del paciente durante la fase inmediata de
                    recuperación tras la anestesia y/o sedación posterior a un procedimiento o una
                    intervención quirúrgica.
                </p>
                <h3>
                    2.2.3 Unidad de Pabellones
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Recinto destinado a agrupar un grupo de quirófanos y otras salas. El quirófano es la sala destinada a
                    la realización de intervenciones quirúrgicas mayores en condiciones de máxima seguridad para el
                    paciente. Usted debe identificar en cada pabellón el número de quirófanos que lo forman.
                </p>
                <h3>
                    2.2.4 Servicios de Urgencia
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Es el área responsable de dar atención médica a los pacientes que se encuentran en una
                    condición de salud de o cuadro clínico de emergencia o urgencia. Usted debe elegir entre
                    las opciones, cuál es la característica del servicio de urgencia de la institución.
                    Si posee más de un servicio de urgencia, debe completarlos por separado.
                </p>
                <ul style={{ padding: 5, marginLeft: 15 }}>
                    <li style={{ padding: 5 }}>
                        General Indiferenciada: la institución sólo posee un área de urgencia, independientemente
                        del tipo de pacientes que atiende. Incluye pacientes adultos o pediátricos
                    </li>
                    <li style={{ padding: 5 }}>
                        Adulta: la institución posee un área solo destinada a la atención de urgencia de pacientes adultos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Pediátrica: la institución posee un área solo destinada a la atención de urgencia de pacientes pediátricos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Maternidad: la institución posee un área solo destinada a la atención de urgencia de pacientes obstétricos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Dental: la institución posee un área solo destinada a la atención de urgencia de pacientes odontológicos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Escolar: la institución posee un área solo destinada a la atención de urgencia de pacientes con seguro escolar.
                    </li>
                </ul>
                <h3>
                    2.2.5 Área Ambulatoria
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Se refiere a las áreas de atención de pacientes ambulatorios, no incluye hospitalización.
                </p>
                <ul style={{ padding: 5, marginLeft: 15 }}>
                    <li style={{ padding: 5 }}>
                        Centros Médicos/Dependientes: Aplica para instituciones de atención cerrada pública y
                        privada. Ingrese, si corresponde, los centros dependientes de su institución. Podría
                        ser más de un tipo. En este caso, debe completar la información solicitada para cada
                        uno de ellos. En este ítem usted debe agregar el horario de atención del centro
                        dependiente. Si usted presiona Agregar, el centro quedará automáticamente registrado
                        en la lista.
                    </li>
                    <li style={{ padding: 5 }}>
                        Pabellón Cirugía Menor: Recinto destinado a realizar intervenciones quirúrgicas médicas
                        u odontológicas, que no requieren la hospitalización del paciente, al que se le aplica
                        sedación y/o anestesia local. Estos deberán formar parte de un establecimiento de salud
                        o ser dependencia anexa a consultas de profesionales.
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidad Oncológica y Alivio del Dolor: una unidad que administra el tratamiento de fármacos
                        citotóxicos, terapia biológica u otras, a pacientes oncológicos (con tumores sólidos) o
                        hematológicos, sin hacer separación entre ellos, mediante vía oral o inyectable. Corresponde
                        a una unidad independiente de tratamiento, donde podrá́ administrarse también, a algunos
                        pacientes, terapias complementarias a la quimioterapia (medicamentos coadyuvantes como para
                        náuseas y vómitos, deshidratación leve a moderada, transfusión, heparinización de catéteres,
                        entre otras) y que no requieran mantener al paciente hospitalizado. Cuidados Paliativos
                        (CP): Corresponde a una unidad normalmente dependiente de Oncología, aunque podría atender
                        pacientes no oncológicos. Los sillones de quimioterapia pueden ser en cubículos
                        individuales o agrupados en torno a la estación de enfermería o a un mesón de
                        observación. Usted debe colocar el número de sillones por sala o el número de
                        cubículos, en el caso que sean individuales.
                    </li>
                    <li style={{ padding: 5 }}>
                        Radioterapia: unidad donde se aplica a los pacientes radiaciones para eliminar un crecimiento
                        celular anormal o desregulado.
                    </li>
                    <li style={{ padding: 5 }}>
                        Salas de Procedimientos: Espacios destinados a realizar diferentes tipos de procedimientos
                        médicos y de enfermería. Se subdividen en salas de procedimientos invasivos y no invasivos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Vacunatorio. recinto destinado al almacenamiento y administración de vacunas a pacientes ambulatorios.
                    </li>
                    <li style={{ padding: 5 }}>
                        Consultas Profesionales: recinto destinado a la atención profesional de pacientes ambulatorios.
                    </li>
                </ul>
                <h3>
                    2.2.6 Áreas de apoyos
                </h3>
                <ul style={{ padding: 5, marginLeft: 15 }}>
                    <li style={{ padding: 5 }}>
                        Imagenología: recinto donde se realizan distintos exámenes y procedimientos para
                        revelar, diagnosticar y examinar enfermedades o para estudiar la anatomía y
                        las funciones del cuerpo.
                    </li>
                    <li style={{ padding: 5 }}>
                        Laboratorio Clínico: recinto donde se realizan distintos tipos de análisis clínicos.
                        Esto es con el fin de ayudar en el diagnóstico y tratamiento de enfermedades.
                    </li>
                    <li style={{ padding: 5 }}>
                        Central de Esterilización: es aquella donde se realiza el proceso de producción de
                        material estéril para su uso clínico o, lo que es lo mismo, recibe, acondiciona,
                        procesa, controla, almacena y distribuye textiles, equipamiento biomédico e
                        instrumental a otras unidades y servicios sanitarios, tanto hospitalarios como
                        extrahospitalarios, con el fin de garantizar la seguridad biológica de estos
                        productos para ser utilizados con el paciente.
                    </li>
                    <li style={{ padding: 5 }}>
                        Farmacia: es el establecimiento sanitario encargado de la creación, distribución y
                        control de los medicamentos. Puede ser sólo de atención interna (atención cerrada)
                        o de dispensación a pacientes ambulatorios (atención abierta)
                    </li>
                    <li style={{ padding: 5 }}>
                        Botiquín: es el establecimiento sanitario encargado de la distribución y control de los
                        medicamentos. Puede ser sólo de atención interna (atención cerrada) o de dispensación
                        a pacientes ambulatorios (atención abierta).
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidad de Diálisis: unidad asistencial, hospitalaria o extrahospitalaria que proporciona
                        tratamiento dialítico al paciente que lo requiera.
                    </li>
                    <li style={{ padding: 5 }}>
                        Odontología: unidad destinada al tratamiento de pacientes con patología dental de tipo ambulatorio.
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidades de Medicina Transfuncional (UTM): unidad de apoyo diagnóstico y terapéutico,
                        cuyo objetivo primordial es efectuar terapia transfusional de manera oportuna, segura,
                        de calidad e informada. En Hospitales de Mediana Complejidad por lo general cuenta con
                        Centro de Sangre Regional, y está inserta dentro de la Unidad de Laboratorio, por lo
                        que no requiere de muchos recintos y comparte varios con Laboratorio.
                    </li>
                    <li style={{ padding: 5 }}>
                        Transporte de Pacientes: Se refiere a la cantidad de ambulancias destinadas al transporte
                        de pacientes en la institución, subdivididas en Ambulancias básicas, Ambulancias
                        medicalizadas y Ambulancias avanzadas.
                    </li>
                    <li style={{ padding: 5 }}>
                        Anatomía Patológica: unidad de apoyo diagnóstico que se enfoca en el estudio de las
                        enfermedades a través del examen de tejidos, órganos y células.
                    </li>
                    <li style={{ padding: 5 }}>
                        Medicina Nuclear: unidad de apoyo diagnóstico cuyo propósito es el estudio, diagnóstico y
                        tratamiento de diversas patologías, benignas y malignas, tanto en pacientes adultos como
                        pediátricos, realizando procedimientos estáticos, dinámicos, SPECT e intervencionales.
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidad de Medicina Física y Rehabilitación: también conocida como unidad de fisiatría es
                        donde se atienden pacientes   con afecciones del sistema muscular, esquelético y neurológico.
                    </li>
                </ul>
                <h3>
                    2.7 Salas de procedimiento
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Al elegir en el Menú salas de procedimiento, aparecerán las salas invasivas y no invasivas.
                    Usted debe seleccionar las que están presente en su institución.
                </p>
                <h3>
                    3 Módulo Equipamiento
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Usted debe completar el equipamiento correspondiente al servicio existente en su institución.
                    Usted debe seleccionar el equipo y completar la información solicitada. Para algunos de los
                    equipos, usted deberá ingresar la autorización sanitaria (si corresponde).
                </p>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Equipamiento general ambulatorio y equipamiento general hospitalizado: se
                    refieren a el equipamiento general del área ambulatoria y hospitalizada.
                </p>
                <h3>
                    4 Módulo Dotación de personal
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    En este módulo del sistema, se realizará la carga del personal de salud del prestador institucional,
                    esta funcionalidad está conectada al Registro Nacional de Prestadores Individuales, por lo cual
                    hay información que se cargará automáticamente. para poblar los datos. Para facilitar el llenado,
                    usted podrá realizar una carga masiva de profesionales, en una Plantilla con formato y la
                    Información con los códigos que se deben utilizar para las columnas de sexo, profesión, tipo
                    de jornada, tipo de contrato, unidad funcional y objetor de conciencia.
                </p>
                <h3>
                    5 Definiciones
                </h3>
                <ul style={{ padding: 5, marginLeft: 15 }}>
                    <li style={{ padding: 5 }}>
                        Atención Primaria: Los servicios de Atención Primaria, son los servicios de primer contacto de
                        tipo promocional, preventivo, curativo y de rehabilitación para la población inscrita, que
                        se encuentran contenidos en el Plan de Salud Familiar (PSF), en el Régimen de Garantías
                        Explícitas en Salud (GES) y en los programas de reforzamiento.
                    </li>
                    <li style={{ padding: 5 }}>
                        Atención Secundaria: Corresponde a los prestadores institucionales, que brindan atención
                        ambulatoria y sólo a pacientes que hayan sido derivados desde el nivel primario o tras
                        consultar las Unidades de Emergencia, cuando el profesional de la salud ha determinado
                        que requiere atención de mayor complejidad.
                    </li>
                    <li style={{ padding: 5 }}>
                        Atención Terciaria: Está constituida por los prestadores institucionales de atención cerrada
                        (Hospitales). En ellos se realizan actividades de alta complejidad, aunque también tienen
                        funciones del nivel secundario.
                    </li>
                    <li style={{ padding: 5 }}>
                        Autorización Sanitaria: Es el acto por el medio del cual la Autoridad Sanitaria Regional
                        (secretario regional Ministerial de Salud) permite el funcionamiento de los Prestadores
                        Institucionales de Salud, verificando que ellos cumplen con los requisitos de estructura
                        y organización, expresados en reglamentos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Banco de sangre: Unidad de apoyo diagnóstico y terapéutico localizada dentro de un
                        establecimiento de salud, que efectúa promoción de la donación y colecta de sangre,
                        producción de componentes sanguíneos, almacenamiento, calificación microbiológica
                        e inmunohematológica, con el objeto de efectuar la terapia transfusional en el
                        propio centro asistencial
                    </li>
                    <li style={{ padding: 5 }}>
                        Centros de Salud Familiar (CESFAM): Proporcionan cuidados básicos en salud, con acciones
                        de promoción, prevención, curación, tratamiento, cuidados domiciliarios y rehabilitación
                        de la salud; y atienden en forma ambulatoria. La diferencia entre un CES y un CESFAM es
                        que en este último se trabaja bajo el Modelo de Salud Integral con Enfoque Familiar y
                        Comunitario, y por tanto, se da más énfasis a la prevención y promoción de salud, se
                        centra en las familias y la comunidad, da importancia a la participación comunitaria,
                        trabaja con un equipo de salud de cabecera que atiende a toda la familia en salud y
                        enfermedad durante todo el ciclo vital y con estas acciones pretende mejorar la calidad
                        de vida de las personas
                    </li>
                    <li style={{ padding: 5 }}>
                        Centros Comunitarios de Salud Familiar (CECOSF). Centro Comunitario de Salud Familiar,
                        brinda atenciones básicas de salud y trabaja al alero de un Centro de Salud (CES) o
                        CESFAM, dependiendo de éstos para prestaciones más complejas. Pretende acercar la
                        atención de salud aún más a las personas. Por su cercanía con la comunidad y la
                        definición conjunta de las acciones que allí se otorgan, el CECOSF pretende resolver
                        de manera más oportuna la demanda de necesidades de salud de la población a cargo.
                        Atienden en horario hábil de 08:00 a 17:00 hrs. y en extensión horaria hasta las
                        20:00 hrs. Población a cargo: entre 2 mil y 5 mil habitantes, aproximadamente.
                    </li>
                    <li style={{ padding: 5 }}>
                        COSAM: Centros Comunitario de Salud Mental Familiar. Un Centro Comunitario de Salud Mental
                        Familiar, COSAM, se define como un establecimiento de atención ambulatoria, dedicado al
                        área de salud mental y psiquiatría, que apoya y complementa a los consultorios de la
                        comuna en la cual funciona. Los COSAM son un nodo fundamental en la reforma comunitaria
                        de la salud mental para satisfacer los diversos requerimientos en salud mental y psiquiatría,
                        de manera de dar respuesta a la creciente y compleja demanda territorial de atención de
                        patologías de moderada y severa intensidad que hasta ese momento eran absorbidas por los
                        centros de APS o por los Servicios de psiquiatría de los hospitales. De esta manera, el
                        COSAM surge como un centro de salud mental familiar de nivel de complejidad secundaria
                        que permite dar respuesta de especialidad de manera ambulatoria a los usuarios de una
                        comuna con presencia de patología de salud mental, así como apoyo, educación y
                        orientación a sus familiares y cuidadores. El COSAM otorga atención a los usuarios
                        residentes en la comuna, beneficiarios de FONASA o PRAIS, inscritos y derivados
                        desde el CESFAM, consultorios o estaciones Médicas de Barrio, así como de hospitales,
                        Tribunales de Familia y otras instancias del poder judicial con motivo de evaluaciones.
                    </li>
                    <li style={{ padding: 5 }}>
                        Centros de Salud Urbano (CSU):  Es un establecimiento de atención ambulatoria para poblaciones
                        asignadas no superiores a 40.000 habitantes, que puede estar adosado a un hospital de
                        baja complejidad.
                    </li>
                    <li style={{ padding: 5 }}>
                        Centros de Salud Rural (CSR):  Es un establecimiento de atención ambulatoria, en su mayoría
                        administrados por las municipalidades.
                    </li>
                    <li style={{ padding: 5 }}>
                        Centros Comunitarios de Rehabilitación (CCR): Es un establecimiento que colaborará con la
                        participación en comunidad de las personas en situación de discapacidad de origen físico,
                        residentes en la comuna de La Pintana, a través de un modelo de rehabilitación integral,
                        de salud familiar y comunitario.
                    </li>
                    <li style={{ padding: 5 }}>
                        Consultorio General Urbano (CGU): Es el establecimiento de atención ambulatoria ubicado en
                        localidades de más de 20.000 habitantes y al servicio de un área de atracción, idealmente
                        no superior a 50.000 habitantes. Sus acciones comprenden el fomento, la prevención y la
                        protección de la salud de las personas y del ambiente de la localidad y la resolución de
                        los problemas de salud de esa misma población y de aquella del área de atracción que
                        llegue por referencia. La capacidad de resolución de salud ambulatoria estará determinada
                        por la complejidad de los recursos que posea el consultorio. El equipo del Consultorio
                        General Urbano estará constituido por médicos y odontólogos generales, más los
                        profesionales y técnicos (enfermeras, matronas, nutricionistas, etc.) al cual se le
                        agregará el tecnólogo médico para el manejo del laboratorio básico que pueda poseer
                        el establecimiento.
                    </li>
                    <li style={{ padding: 5 }}>
                        Consultorio General Rural (CGR): Es un establecimiento de atención ambulatoria ubicado
                        generalmente en localidades de 2.000 a 5.000 habitantes y que presta servicios a la
                        población de un área determinada que no excede los 20.000 habitantes. Las acciones
                        del Consultorio General Rural comprenden tanto el fomento, la prevención y la protección
                        de la salud de las personas y del medio ambiente, como la resolución de problemas de
                        salud que pueda manejar el equipo de salud compuesto de médico, odontólogo, enfermera
                        matrona, otros profesionales y técnicos apoyados por medios básicos de diagnósticos y
                        tratamiento.
                    </li>
                    <li style={{ padding: 5 }}>
                        Demostración sanitaria: Los establecimientos construidos antes de febrero del año 2006
                        están autorizados por Ley. Para ingresar al proceso de Acreditación deben realizar un
                        “Proceso de Demostración” del cumplimiento de los requisitos de Autorización Sanitaria
                        según Ord. B°/N° 1863, de mayo de 2009, de Subsecretarías de Salud Pública y de Redes
                        Asistenciales.
                    </li>
                    <li style={{ padding: 5 }}>
                        Espacio de almacenamiento: Lugar para almacenamiento en general, el que puede ser un
                        mueble, estantes, repisa o carro.  De material liso y lavable, mobiliario de
                        material lavable, no poroso, bordes lisos y resistentes a desinfectantes habituales
                    </li>
                    <li style={{ padding: 5 }}>
                        Establecimientos de atención ambulatoria: Establecimientos de salud destinados a efectuar
                        atenciones y/o procedimientos de salud, de diagnóstico o terapéuticos, en pacientes
                        ambulatorios, y que no requieren de hospitalización. De todas formas, los Hospitales y
                        clínicas pueden contar con sectores de atención y unidades de apoyo ambulatorias, siempre
                        que ello no interrumpa la continuidad de la atención.
                    </li>
                    <li style={{ padding: 5 }}>
                        Estación Médico Rural.  Son centros para la atención de salud ambulatoria básica, cuyo
                        espacio físico es cedido por la comunidad. Estos no poseen auxiliar permanente, sino
                        que son atendidos por un Equipo de Salud Rural que acude en rondas periódicas.
                    </li>
                    <li style={{ padding: 5 }}>
                        Hospital: Establecimiento que atiende a pacientes cuyo estado de salud requiere de atención
                        profesional médica y de enfermería continua, organizado en servicios clínicos y unidades de
                        apoyo diagnóstico y terapéutico diferenciados.
                    </li>
                    <li style={{ padding: 5 }}>
                        Hospital autogestionado en red: Tienen mayor complejidad técnica, ya que incluyen el
                        desarrollo de especialidades y una organización administrativa. Están descentralizados,
                        pero su función asistencial es determinada por el director de Servicio de acuerdo con
                        los requerimientos.
                    </li>
                    <li style={{ padding: 5 }}>
                        Hospital de menor complejidad: Dependen del Servicio de Salud al que pertenecen y su rol
                        está determinado por la Red correspondiente. Incluyen a los establecimientos de atención
                        primaria.
                    </li>
                    <li style={{ padding: 5 }}>
                        Lámpara quirúrgica: Equipo fijo o móvil para iluminar el campo quirúrgico durante la
                        exploración o maniobras quirúrgicas. Con una intensidad lumínica mínima de 80.000 luxes.
                    </li>
                    <li style={{ padding: 5 }}>
                        Lámpara de procedimientos: Equipo fijo o móvil de iluminación eléctrica para la examinación
                        de pacientes y procedimientos. Intensidad mínima de 40.000 luxes o mayor.
                    </li>
                    <li style={{ padding: 5 }}>
                        Lámpara de exámenes: Equipo fijo o móvil de iluminación eléctrica para la examinación durante
                        la exploración física del paciente. Intensidad mínima de 20.000 luxes o mayor.
                    </li>
                    <li style={{ padding: 5 }}>
                        Ordenanza general de urbanismo y construcción (OGUC): Es el reglamento que contiene las
                        disposiciones reglamentarias que regula los procedimientos administrativos, el proceso
                        de la planificación urbana, la urbanización de los terrenos, la construcción y los
                        estándares técnicos de diseño y construcción exigibles en la urbanización y la construcción.
                    </li>
                    <li style={{ padding: 5 }}>
                        Postas de Salud Rural. Brinda atención que cubre las necesidades de salud de sectores de
                        población rural. Preferentemente de fomento y protección de la salud, promoción, prevención,
                        trabajo comunitario en salud y a su vez, recepción y atención de problemas de salud,
                        derivando a otros establecimientos de la red las situaciones que no pueden ser resueltas
                        en ese nivel y las urgencias que presentan los habitantes de la localidad. Cuentan con
                        un técnico paramédico residente, disponible en forma permanente e inmediata, y con un
                        sistema de comunicación radial con su centro de referencia.
                    </li>
                    <li style={{ padding: 5 }}>
                        Recepción de obras municipal: Trámite que debe cumplir una edificación, para que sea reconocida
                        como tal por la Dirección de Obras Municipal y quede en cumplimiento de la normativa de
                        edificación vigente, el cual finaliza con la emisión de un Certificado de Recepción final de
                        obras Municipal.
                    </li>
                    <li style={{ padding: 5 }}>
                        Recinto: Lugar comprendido dentro de ciertos límites físicos como paredes, cielos, puertas.
                    </li>
                    <li style={{ padding: 5 }}>
                        Residencia de personal: Espacio equipado para el descanso de personal, separado de la sala
                        de estar, que permite al menos una pausa durante el turno nocturno, sin interrupción.
                    </li>
                    <li style={{ padding: 5 }}>
                        Sala de acopio transitorio de residuos: Lugar destinado al estacionamiento transitorio de
                        contenedores, asignado a cada servicio o zona de generación de residuos, para el posterior
                        retiro y traslado a la sala de almacenamiento de REAS (Residuos de establecimientos de
                        atención de salud) del establecimiento.
                    </li>
                    <li style={{ padding: 5 }}>
                        Sala de espera: Área destinada a la permanencia de usuarios y acompañantes en espera de
                        atención clínica. Deben estar proporcionadas a la cantidad de público que atiende el
                        establecimiento, pudiendo parcelarse por áreas o servicios clínicos. Cercanas a ellas
                        se localizarán baños públicos, idealmente equipados con mudador.
                    </li>
                    <li style={{ padding: 5 }}>
                        Sala de entrevista con familiares: Recinto para informar al paciente y sus familiares de
                        las condiciones, procedimientos y cuidados que este debe tener, debe permitir un ambiente
                        privado y cómodo.
                    </li>
                    <li style={{ padding: 5 }}>
                        Servicios de Urgencia de Alta Resolución: Entregan atención médica de urgencia, oportuna,
                        resolutiva y de calidad, a la población inscrita, en un horario que complementa el
                        funcionamiento del CESFAM y SAPU. El propósito es que las personas no concurran a un
                        servicio de emergencia hospitalaria, si se trata de una patología de baja complejidad,
                        asegurando así la continuidad de la atención y coordinando la adecuada derivación del
                        usuario a su equipo de salud de cabecera cuando corresponda. Tienen mayor capacidad
                        resolutiva, mejor equipamiento y tecnología, más personal y una ambulancia para
                        trasladado al hospital.
                    </li>
                    <li style={{ padding: 5 }}>
                        Servicio de Atención Primaria de Urgencia. Un Servicio de Atención Primaria de Urgencia (SAPU)
                        es un establecimiento de salud que ofrece atención a las necesidades de urgencia/emergencia1
                        de baja complejidad, que se emplaza adosado a un Centro de Salud de Atención Primaria o en
                        un local anexo. Depende técnica y administrativamente de éste o, en su defecto, de quien
                        la autoridad sanitaria local determine, y cumple la función de entregar prestaciones de
                        emergencia /urgencia médica en horario no hábil.
                    </li>
                    <li style={{ padding: 5 }}>
                        Servicios de Salud: Son 29 a nivel nacional y poseen una red asistencial formada por hospitales,
                        bajo los cuales tienen dependencia, y establecimientos municipales de atención primaria en los
                        que tienen injerencia programática y de presupuesto, pero no administrativa.
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidad de Paciente: Es el área ocupada por el mobiliario y todas las instalaciones complementarias
                        utilizadas para el tratamiento del paciente durante su atención, ya sea esta mediante
                        hospitalización, o de manera ambulatoria. En salas compartidas, ya sea de atención ambulatoria u
                        hospitalaria deberá existir una separación entre cada unidad de paciente de al menos 120cm, que
                        debe medirse entre los bordes laterales contiguos entre camillas/camas/cunas, según corresponda.
                    </li>
                    <li style={{ padding: 5 }}>
                        Unidad de Medicina Transfusional (UMT): es una unidad de apoyo diagnóstico y terapéutico de un
                        establecimiento de salud público o privado, cuya función primordial es efectuar terapia
                        transfusional con indicación sujeta a guías nacionales de manera oportuna, segura, de calidad,
                        informada, y costo eficiente. Realiza procesos de hemovigilancia y procedimientos que permitan
                        la trazabilidad.
                    </li>
                </ul>
                <h3>
                    Atención de Hospitalización
                </h3>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                    Aquellos funcionarios/ias que desempeñan funciones clínicas de atención directa con el usuario
                    hospitalizado en camas de acuerdo al nivel de cuidados (Básico, Medio o crítico) en cualquier
                    centro de salud de Nivel II o III, tanto público como privado. A continuación, se detallan los
                    niveles de cuidado:
                </p>
                <ol style={{ padding: 5, marginLeft: 15 }} type="1">
                    <li style={{ padding: 5 }}>
                        Nivel de Cuidados Básicos: Este nivel de cuidados está destinado a pacientes que, estando en
                        cualquiera de las etapas de una enfermedad (evaluación, diagnóstico, tratamiento y/o
                        recuperación), requiera hacer uso de instalaciones hospitalarias con el fin de que le sean
                        otorgados cuidados médicos y de enfermería y/o matronería básicos. El perfil de pacientes a
                        ingresar es de riesgo bajo y dependencia parcial o autosuficiencia (categorización riesgo
                        dependencia: C3-DI-D2-D3). Ejemplo: área médico  adulto básica, área  médico quirúrgico
                        pediátrico básica.
                    </li>
                    <li style={{ padding: 5 }}>
                        <p>
                            Nivel de Cuidados Medios: Este nivel está destinado a entregar cuidados a pacientes de mediana
                            complejidad. Se asocian a una fase aguda de enfermedad paciente, que en general debiera
                            compensarse en pocos días.
                        </p>
                        Los ingresos a este nivel de atención son pacientes provenientes de las unidades de emergencia
                        y camas críticas. En estas unidades se debe mantener una vigilancia estrecha y periódica de
                        los parámetros vitales de los pacientes, además de realiza atención integral con alta demanda
                        de cuidados de Enfermería y/o Matronería según corresponda, por lo tanto, el perfil de
                        pacientes a ingresar es con mediano riesgo y alta dependencia (categorización riesgo
                        dependencia Cl-C2-B3). Ejemplo: área médico-quirúrgico cuidados medios.
                    </li>
                    <li style={{ padding: 5 }}>
                        <p>
                            Nivel de Cuidados Críticos: Es el nivel de cuidados destinado a brindar cuidados de alta complejidad
                            definida para la hospitalización y atención de pacientes críticos, es decir, con una condición
                            patológica que afecta uno o más sistemas, que pone en serio riesgo actual o potencial su vida y que
                            presenta condiciones de reversibilidad. Para ellos se hace necesaria la aplicación de técnicas de
                            monitorización, vigilancia, manejo y soporte vital avanzado hasta la compensación de sus signos
                            vitales y hemodinámicos.
                        </p>

                        Este nivel organiza sus camas en Unidades de Pacientes Críticos (UPC) con áreas de cuidado intensivo y
                        tratamiento intermedio. El perfil de pacientes a ingresar es máximo o alto riesgo y dependencia total
                        (categorización riesgo dependencia Al-A2-A3-B1-B2). Ejemplo: área de cuidados intensivos adulto, área
                        de tratamiento intermedio adulto, área de cuidados intensivos pediatría.
                    </li>
                    <li style={{ padding: 5 }}>
                        Atención de Urgencia: Aquellos funcionarios/ias que desempeñan funciones clínicas de atención directa al
                        usuario (inmediata e impostergable) cuya condición clínica implica riesgo de muerte o de secuela
                        funcional grave.
                    </li>
                    <li style={{ padding: 5 }}>
                        Atención Quirúrgica: Es aquel proceso donde se da resolución total o parcial a un problema de salud de
                        tipo quirúrgico. Los funcionarios/ias que se desempeñan en ésta área tienen funciones clínicas de
                        atención directa con el usuario.
                    </li>
                    <li style={{ padding: 5 }}>
                        Apoyo diagnóstico y/o terapéutico: Proveen de distintos productos y/o servicios en todas las etapas del
                        proceso clínico: en el proceso diagnóstico, en el de tratamiento y de seguimiento o rehabilitación.
                        En los procesos de apoyo están considerados Anatomía patológica, Banco de sangre, Laboratorio,
                        Esterilización, Farmacia e Imágenes. Los funcionarios/ias que se desempeñan en ésta área tienen
                        funciones de apoyo a la gestión clínica de atención, en algunos casos con atención directa con el usuario.
                    </li>
                    <li style={{ padding: 5 }}>
                        Apoyo Administrativo: Se entienden como funciones de apoyo a todas aquellas destinadas al funcionamiento
                        de los establecimientos de salud, que dan sustento a este y a la red de salud. Cumplen funciones
                        administrativas, no necesariamente asociadas a la atención directa de personas. Ejemplo: Unidades de
                        Personal (RRHH), Dirección o Gerencia, Mantenimiento, Finanzas, Abastecimiento etc.
                    </li>
                    <li style={{ padding: 5 }}>
                        Atención Ambulatoria: Aquellos funcionarios/ias que desempeñan funciones clínicas de atención directa al
                        usuario quién acude regularmente a un Centro de Salud por razones de Diagnóstico, tratamiento o
                        Rehabilitación, pero que dada su condición clínica se deriva a su hogar o a control, sin necesidad de ser
                        hospitalizado.
                    </li>
                </ol>
                <h3>
                    6 Glosario de términos
                </h3>
                <ul style={{ padding: 5, marginLeft: 15 }}>
                    <li style={{ padding: 5 }}>
                        CESFAM: Centros de Salud Familiar.
                    </li>
                    <li style={{ padding: 5 }}>
                        CECOSF: Centros Comunitarios de Salud Familiar.
                    </li>
                    <li style={{ padding: 5 }}>
                        CES:  Centro de Salud.
                    </li>
                    <li style={{ padding: 5 }}>
                        COSAM: Centros Comunitario de Salud Mental Familiar.
                    </li>
                    <li style={{ padding: 5 }}>
                        CSU: Centros de Salud Urbano.
                    </li>
                    <li style={{ padding: 5 }}>
                        CSR: Centros de Salud Rural.
                    </li>
                    <li style={{ padding: 5 }}>
                        CRS: Centro de Referencia de Salud.
                    </li>
                    <li style={{ padding: 5 }}>
                        CGU: Consultorio General Urbano.
                    </li>
                    <li style={{ padding: 5 }}>
                        CGR: Consultorio General Rural.
                    </li>
                    <li style={{ padding: 5 }}>
                        DEA: Desfibrilador Externo Automático.
                    </li>
                    <li style={{ padding: 5 }}>
                        EMR: Estación Médico Rural.
                    </li>
                    <li style={{ padding: 5 }}>
                        N°:  Número.
                    </li>
                    <li style={{ padding: 5 }}>
                        PSR: Postas de Salud Rural.
                    </li>
                    <li style={{ padding: 5 }}>
                        SAPU: Servicio de Atención Primaria de Urgencia.
                    </li>
                    <li style={{ padding: 5 }}>
                        SAR: Servicios de Urgencia de Alta Resolución.
                    </li>
                </ul>
            </Grid>
        </div>
    )

}


export default AyudaFt